import React from 'react';
import { Button, Card, Col, Row } from 'reactstrap';

import styles from './Filters.module.scss';

import TimeFilter from './time/TimeFilter';
import LocationFilter from './location/LocationFilter';
import ProductFilter from './product/ProductFilter';

import { GetPlanId } from '../../../helpers/Helpers';
import Environment from '../../../environment/Environment';

import { GetFilteredData, UpdateFilterData } from '../../../api-services/filters.api';

interface Props {
  timeSelection: string;
  locationSelection?: string;
  productSelection?: string;
  history?: any;
  onUpdateFilter?: () => void;
}

interface State {
  isExpanded: boolean,
  filteredData: any;
  isTimeSelected: boolean;
  isLocationSelected: boolean;
  isProductSelected: boolean;
}

export default class Filters extends React.Component<Props, State> {
  private _reactInternals: any;

  constructor(props) {
    super(props);

    this.state = {
      isExpanded: true,
      filteredData: null,
      isTimeSelected: false,
      isLocationSelected: false,
      isProductSelected: false
    };
  }

  componentDidMount(): void {
    if (this.props.history.location.search.includes('filter')) {
      const data = sessionStorage.getItem(Environment.PROJECT + 'filter');

      if (!!data) {
        const filterData = JSON.parse(data);
        this.setState({
          filteredData: filterData,
          isTimeSelected: !!filterData.time_filter.time.length,
          isLocationSelected: !!filterData.store_filter.levels.length,
          isProductSelected: !!filterData.product_filter.levels.length
        }, () => {
          this.updateFilterData();
        });
      }
    } else {
      this.getFilteredData(true);
    }
  }

  getFilteredData(refresh: boolean): void {
    const params = {
      planId: GetPlanId(this.props.history.location.pathname) || 1
    };

    GetFilteredData(params)
      .then((res) => {
        if (!!res) {
          this.setState({
            filteredData: res,
            isTimeSelected: (this.props.history.location.pathname !== '/planning-window-configuration' &&
                            this.props.history.location.pathname !== '/run-rate-plan')
                            ? !!res.time_filter.time.length : true,
            isLocationSelected: !!res.store_filter.levels.length,
            isProductSelected: !!res.product_filter.levels.length
          }, () => {
            if (refresh && !!this.state.isTimeSelected && !!this.state.isLocationSelected && !!this.state.isProductSelected) {
              this.props.onUpdateFilter && this.props.onUpdateFilter();
            }

            sessionStorage.setItem(Environment.PROJECT + 'filter', JSON.stringify(this.state.filteredData));
          });
        }
      });
  }

  updateFilterData(): void {
    const payload = {
      filter: this.state.filteredData
    };

    const params = {
      planId: GetPlanId(this.props.history.location.pathname)
    };

    UpdateFilterData(payload, params)
      .then((response) => {
        if(!!response){
          this.props.onUpdateFilter && this.props.onUpdateFilter();
        }
      });
  }

  buttonStatus(): boolean {
    return this.state.isTimeSelected && this.state.isLocationSelected && this.state.isProductSelected;
  }

   pageBreadcrumb(path: string): string {
    return path.replace(/-/g, ' ');
  }

  navigationHandler(path: string): void {
    if (path !== '') {
      this.props.history.replace(`/${path}`);
    } else {
      this.props.history.replace('/dashboard');
    }
  }

  render(): React.ReactNode {
    if (!!!this.state.filteredData) {
      return null;
    }

    return (
      <React.Fragment>
        <Row>
          <Col md={12}>

            <Card className={styles['filter-card']}>
              {/*<Row>
                <Col md={10}>
                  <p className={styles['filter-header-text']}>Filters</p>
                </Col>
                <p className="text-right col-md-2">
                  <i className={`ri-arrow-${this.state.isExpanded ? 'down' : 'up'}-s-line p-2 cursor-pointer`}
                     style={{fontSize: '22px'}}
                     onClick={() => this.setState({isExpanded: !this.state.isExpanded})}
                  />
                </p>
              </Row>*/}

              <Row>
                {
                  this.state.isExpanded &&
                  <React.Fragment>
                    <Col md={2} className="d-flex align-items-center">
                    <p>
                      <i className="ri-filter-2-line font-size-20 me-2"/>
                        <span className={styles['section-label']}>Filters</span>
                        <br></br>
                      <span className="mt-1 subtitle">
                          {
                            this.props.history.location.pathname.split('/').map((path, idx: number) => (
                              <React.Fragment key={idx}>
                                <span
                                  className={
                                    this.props.history.location.pathname.split('/').length - 1 !== idx
                                      ? 'text-primary cursor-pointer'
                                      : ''}
                                  onClick={() => this.props.history.location.pathname.split('/').length - 1 !== idx &&
                                    this.navigationHandler(path)}
                                >
                                  {path === '' ? 'Home' : this.pageBreadcrumb(path)}
                                  {
                                    this.props.history.location.pathname.split('/').length - 1 !== idx &&
                                    <i className="ri-arrow-drop-right-line align-middle font-size-22 icon-color"/>
                                  }
                                </span>
                              </React.Fragment>
                            ))
                          }
                      </span>
                    </p>
                      
                    </Col>
                    
                    {this._reactInternals?._debugOwner?.elementType?.name !== 'PlanningWindowConfiguration' &&
                     this._reactInternals?._debugOwner?.elementType?.name !== 'RunRatePlan' &&
                    <Col md={3}>
                      <TimeFilter
                        isSingle={this.props.timeSelection === 'single'}
                        history={this.props.history}
                        selectedData={this.state.filteredData.time_filter}
                        updateSelection={(status: boolean) => this.setState({ isTimeSelected: status })}
                      />
                    </Col>
                    }

                    <Col md={3}>
                      <LocationFilter
                        selection={this.props.locationSelection || 'single'}
                        history={this.props.history}
                        selectedData={this.state.filteredData.store_filter}
                        updateSelection={(status: boolean) =>
                          this.setState({
                            isLocationSelected: status
                          }, () => {
                            this.getFilteredData(false);
                          })
                        }
                      />
                    </Col>

                    <Col md={3}>
                      <ProductFilter
                        selection={this.props.productSelection || 'single'}
                        history={this.props.history}
                        selectedData={this.state.filteredData.product_filter}
                        selectedLocationData={this.state.filteredData.store_filter}
                        updateSelection={(status: boolean) =>{
                          this.setState({
                            isProductSelected: status
                          }, () => {
                            this.getFilteredData(false);
                          })

                          this.props.onUpdateFilter && this.props.onUpdateFilter();
                      }}
                      />
                    </Col>

                    {(this._reactInternals?._debugOwner?.elementType?.name !== 'PlanningWindowConfiguration' &&
                      this._reactInternals?._debugOwner?.elementType?.name !== 'RunRatePlan')
                      ?
                      <Col
                        md={1}
                        className={styles['filter-button']}
                      >
                        <Button
                          color={'primary'}
                          className="btn btn-primary"
                          disabled={!this.buttonStatus()}
                          onClick={() => {
                            this.props.onUpdateFilter && this.props.onUpdateFilter();
                            this.getFilteredData(true);
                          }}
                        >
                          Apply
                        </Button>
                      </Col>
                      : <Col
                        md={4}
                        className={styles['filter-button']}
                      >
                        <Button
                          color={'primary'}
                          className="btn btn-primary"
                          disabled={!this.buttonStatus()}
                          onClick={() => {
                            this.props.onUpdateFilter && this.props.onUpdateFilter();
                            this.getFilteredData(true);
                          }}
                        >
                          Apply
                        </Button>
                      </Col>

                    }
                  </React.Fragment>
                }
              </Row>

            </Card>

          </Col>
        </Row>
      </React.Fragment>
    );
  }
}
